import { forwardRef } from 'react'
import { cva } from 'class-variance-authority'
import { ButtonBase, ButtonBaseProps } from './button-base'
import { cn } from '@vgw/tailwind-merger'

const buttonFilledVariants = cva(
  [
    'border-gradient-mask',
    'bg-linear-to-b',
    'disabled:from-surface-disabled',
    'disabled:to-surface-disabled',
    'disabled:text-content-disabled',
    'before:bg-linear-to-b',
    'disabled:before:from-transparent',
    'disabled:before:to-transparent',
  ],
  {
    variants: {
      variant: {
        primary: [
          'rounded-button-filled-primary',
          'from-button-filled-surface-primary-0',
          'to-button-filled-surface-primary-100',
          'text-button-filled-content-primary',
          'hover:from-button-filled-surface-primary-hover',
          'hover:to-button-filled-surface-primary-hover',
          'active:from-button-filled-surface-primary-active',
          'active:to-button-filled-surface-primary-active',
          'active:opacity-92',
          'disabled:rounded-button-filled-primary',
          'disabled:active:opacity-100',
          'before:rounded-button-filled-primary',
          'before:p-(--border-width-button-filled-primary)',
          'before:from-button-filled-border-primary-0',
          'before:to-button-filled-border-primary-100',
          'hover:before:from-button-filled-border-primary-hover',
          'hover:before:to-button-filled-border-primary-hover',
          'active:before:from-button-filled-border-primary-active',
          'active:before:to-button-filled-border-primary-active',
        ],
        secondary: [
          'rounded-button-filled-secondary',
          'from-button-filled-surface-secondary-0',
          'to-button-filled-surface-secondary-100',
          'text-button-filled-content-secondary',
          'hover:from-button-filled-surface-secondary-hover',
          'hover:to-button-filled-surface-secondary-hover',
          'active:from-button-filled-surface-secondary-active',
          'active:to-button-filled-surface-secondary-active',
          'active:opacity-92',
          'disabled:rounded-button-filled-secondary',
          'disabled:active:opacity-100',
          'before:rounded-button-filled-secondary',
          'before:p-(--border-width-button-filled-secondary)',
          'before:from-button-filled-border-secondary-0',
          'before:to-button-filled-border-secondary-100',
          'hover:before:from-button-filled-border-secondary-hover',
          'hover:before:to-button-filled-border-secondary-hover',
          'active:before:from-button-filled-border-secondary-active',
          'active:before:to-button-filled-border-secondary-active',
        ],
        tertiary: [
          'rounded-button-filled-primary',
          'from-button-filled-surface-tertiary-0',
          'to-button-filled-surface-tertiary-100',
          'text-button-filled-content-primary',
          'hover:from-button-filled-surface-tertiary-hover',
          'hover:to-button-filled-surface-tertiary-hover',
          'active:from-button-filled-surface-tertiary-active',
          'active:to-button-filled-surface-tertiary-active',
          'active:opacity-92',
          'disabled:rounded-button-filled-primary',
          'disabled:active:opacity-100',
          'before:rounded-button-filled-primary',
          'before:p-(--border-width-button-filled-primary)',
          'before:from-button-filled-border-tertiary-0',
          'before:to-button-filled-border-tertiary-100',
          'hover:before:from-button-filled-border-tertiary-hover',
          'hover:before:to-button-filled-border-tertiary-hover',
          'active:before:from-button-filled-border-tertiary-active',
          'active:before:to-button-filled-border-tertiary-active',
          'disabled:from-surface-tertiary-disabled',
          'disabled:to-surface-tertiary-disabled',
          'disabled:text-content-tertiary-disabled',
        ],
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  },
)

export type ButtonFilledProps = ButtonBaseProps

export const ButtonFilled = forwardRef<HTMLButtonElement, ButtonFilledProps>(
  ({ className, variant = 'primary', ...props }: ButtonFilledProps, ref) => {
    return (
      <ButtonBase
        {...props}
        className={cn(buttonFilledVariants({ variant, className }))}
        variant={variant}
        ref={ref}
      />
    )
  },
)

ButtonFilled.displayName = 'ButtonFilled'
